import React from "react";
import {Box} from "@mui/system";
import {DialogContent, Typography} from "@mui/material";

const emphasisSx = {
    fontWeight: 600,
};

export function ModuleCompositionWidthConfirmDialogContent({
    compositionName,
    moduleName,
    previousValue,
    nextValue,
}) {
    const displayModule = moduleName?.trim() ? moduleName.trim() : "—";
    const displayComposition = compositionName?.trim() ? compositionName.trim() : "—";
    const displayPrevious = previousValue ?? "—";
    const displayNext = nextValue ?? "—";

    return (
        <DialogContent sx={{pt: 0, pb: 2, px: "1.25rem"}}>
            <Typography sx={{fontSize: "16px", lineHeight: 1.5}}>
                Изменить{" "}
                <Box component="span" sx={emphasisSx}>
                    ширину
                </Box>{" "}
                модуля{" "}
                <Box component="span" sx={emphasisSx}>
                    «{displayModule}»
                </Box>{" "}
                в композиции{" "}
                <Box component="span" sx={emphasisSx}>
                    «{displayComposition}»
                </Box>
                {" "}с{" "}
                <Box component="span" sx={emphasisSx}>
                    {displayPrevious}
                </Box>{" "}
                на{" "}
                <Box component="span" sx={emphasisSx}>
                    {displayNext}
                </Box>
                ?
            </Typography>
        </DialogContent>
    );
}
